import React from 'react';
import { Box, IconButton } from '@mui/material';

const SocialIconsBlock = ({ data, isSelected, onUpdate, previewMode, blockId, onSelectBlock }) => {
  // Define allowed platforms as per requirements
  const SOCIAL_MEDIA_PLATFORMS = [
    'Facebook', 'Instagram', 'Odnoklassniki', 'LinkedIn', 'Tik-Tok', 'Twitter', 
    'Twitter-X', 'Pinterest', 'YouTube', 'GitHub', 'Itunes'
  ];

  const MESSENGER_PLATFORMS = [
    'Telegram', 'Vkontakte', 'Messenger Facebook', 'Messenger Line', 
    'Whatsapp', 'Viber', 'Discord'
  ];

  const {
    platforms = [
      { category: 'social', name: 'Facebook', url: '#', show: true },
      { category: 'social', name: 'Twitter', url: '#', show: true },
      { category: 'social', name: 'Instagram', url: '#', show: true },
      { category: 'messenger', name: 'Telegram', url: '#', show: true },
    ],
    iconSize = 32,
    spacing = 10,
    alignment = 'center',
    style = 'colored',
    borderRadius = 50,
    backgroundColor = '#666666',
    iconColor = '#ffffff',
    marginTop = 20,
    marginBottom = 20,
    padding = '15px',
  } = data;

  const containerStyles = {
    textAlign: alignment,
    padding,
    marginTop: `${marginTop}px`,
    marginBottom: `${marginBottom}px`,
    border: isSelected ? '2px dashed #007bff' : 'none',
    borderRadius: isSelected ? '4px' : 0,
  };

  const iconsContainerStyles = {
    display: 'flex',
    justifyContent: alignment === 'center' ? 'center' : alignment === 'right' ? 'flex-end' : 'flex-start',
    alignItems: 'center',
    gap: `${spacing}px`,
    flexWrap: 'wrap',
  };

  // SVG icon mapping to local files
  const getSvgIcon = (platformName) => {
    const normalizedName = platformName.toLowerCase().replace(/[^a-z]/g, '');
    
    const svgMap = {
      // Social Media Platforms
      facebook: '/images/icons/facebook.svg',
      instagram: '/images/icons/instagram.svg',
      odnoklassniki: '/images/icons/od.svg',
      linkedin: '/images/icons/linkedin.svg',
      tiktok: '/images/icons/tiktok.svg',
      twitter: '/images/icons/twitter.svg',
      twitterx: '/images/icons/twitter-x.svg',
      pinterest: '/images/icons/pinterest.svg',
      youtube: '/images/icons/youtube.svg',
      github: '/images/icons/github.svg',
      itunes: '/images/icons/itunes.svg',
      
      // Messenger Platforms
      telegram: '/images/icons/telegram.svg',
      vkontakte: '/images/icons/vkontakte.svg',
      messengerfacebook: '/images/icons/messenger-facebook.svg',
      messengerline: '/images/icons/messenger-line.svg',
      whatsapp: '/images/icons/whatsapp.svg',
      viber: '/images/icons/viber.svg',
      discord: '/images/icons/discord.svg',
    };

    return svgMap[normalizedName] || '/images/icons/facebook.svg'; // fallback
  };

  // Color mapping for different platforms
  const getIconColor = (platformName) => {
    // Если выбран monochrome стиль, возвращаем выбранный цвет фона
    if (style === 'monochrome') {
      return backgroundColor;
    }
    
    const normalizedName = platformName.toLowerCase().replace(/[^a-z]/g, '');
    
    const colorMap = {
      // Social Media Platforms
      facebook: '#1877f2',
      instagram: '#e4405f',
      odnoklassniki: '#ee8208',
      linkedin: '#0077b5',
      tiktok: '#000000',
      twitter: '#1da1f2',
      twitterx: '#000000',
      pinterest: '#bd081c',
      youtube: '#ff0000',
      github: '#181717',
      itunes: '#000000',
      
      // Messenger Platforms
      telegram: '#0088cc',
      vkontakte: '#4680c2',
      messengerfacebook: '#0084ff',
      messengerline: '#00c300',
      whatsapp: '#25d366',
      viber: '#665cac',
      discord: '#5865f2',
    };

    return colorMap[normalizedName] || '#666666';
  };

  const getIconStyles = (platformName) => {
    const baseSize = previewMode === 'mobile' ? Math.max(iconSize * 0.8, 24) : iconSize;
    
    return {
      width: baseSize,
      height: baseSize,
      padding: 0,
      borderRadius: `${borderRadius}%`,
      backgroundColor: getIconColor(platformName),
      transition: 'all 0.3s ease',
      '&:hover': {
        transform: 'scale(1.1)',
        opacity: 0.8,
          },
        };
  };

  const handleIconClick = (platform) => {
    if (platform.url && platform.url !== '#') {
      window.open(platform.url, '_blank');
    }
  };

  // Filter platforms to only show allowed ones
  const allVisiblePlatforms = platforms.filter(p => {
    if (!p.show) return false;
    
    const allowedPlatforms = [
      ...SOCIAL_MEDIA_PLATFORMS,
      ...MESSENGER_PLATFORMS
    ];
    
    return allowedPlatforms.includes(p.name);
  });

  return (
    <Box sx={containerStyles}>
      <Box sx={iconsContainerStyles}>
        {allVisiblePlatforms.map((platform, index) => {
          const svgPath = getSvgIcon(platform.name);
          return (
            <IconButton
              key={`${platform.category}-${platform.name}-${index}`}
              sx={getIconStyles(platform.name)}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleIconClick(platform);
              }}
              title={`${platform.name} - ${platform.category === 'social' ? 'Social Media' : 'Messenger'}`}
            >
              {style === 'monochrome' ? (
                <Box
                  sx={{
                    width: '60%',
                    height: '60%',
                    backgroundColor: iconColor,
                    mask: `url(${svgPath}) no-repeat center/contain`,
                    WebkitMask: `url(${svgPath}) no-repeat center/contain`,
                  }}
                />
              ) : (
                <img
                  src={svgPath}
                  alt={platform.name}
                  style={{
                    width: '60%',
                    height: '60%',
                    objectFit: 'contain',
                  }}
                />
              )}
            </IconButton>
          );
        })}
      </Box>
    </Box>
  );
};

export default SocialIconsBlock; 